import React, { useState } from 'react';
import { fmtPesos } from '../engine/perfil';

// S6 · Accesorios no de fábrica (Carlos, 14-oct): tipo + valor; se suman al valor asegurado. Sin humano.
const TIPOS = ['Blindaje', 'Rines de lujo', 'Sonido', 'Vidrios de seguridad', 'Tapicería de cuero', 'Otro'];

export const Accesorios = ({ onListo, locked, base }) => {
  const [items, setItems] = useState([]);
  const [tipo, setTipo] = useState(TIPOS[1]);
  const [valor, setValor] = useState('');
  const [confirmar, setConfirmar] = useState(false);
  const n = Number(valor.replace(/\D/g, '')) || 0;
  const total = items.reduce((s, x) => s + x.valor, 0);
  const agregar = (e) => {
    e.preventDefault();
    if (!n) return;
    setItems((xs) => [...xs, { tipo, valor: n }]);
    setValor('');
  };
  const texto = () => `${items.map((x) => `${x.tipo} ${fmtPesos(x.valor)}`).join(' · ')} · total ${fmtPesos(total)}`;
  return (
    <div className="acc" data-testid="accesorios">
      {items.length ? (
        <ul className="acc-lista">
          {items.map((x, i) => (
            <li key={i}>
              <span>{x.tipo}</span><b>{fmtPesos(x.valor)}</b>
              {!confirmar ? <button type="button" aria-label={`Quitar ${x.tipo}`} disabled={locked} onClick={() => setItems((xs) => xs.filter((_, j) => j !== i))}>×</button> : null}
            </li>
          ))}
          <li className="acc-total"><span>Total en accesorios</span><b data-testid="acc-total">{fmtPesos(total)}</b></li>
        </ul>
      ) : null}
      {!confirmar ? (
        <>
          <form className="acc-form" onSubmit={agregar}>
            <select value={tipo} onChange={(e) => setTipo(e.target.value)} disabled={locked} data-testid="acc-tipo">
              {TIPOS.map((t) => <option key={t}>{t}</option>)}
            </select>
            <div className="pp-in">
              <span>$</span>
              <input inputMode="numeric" placeholder="¿Cuánto costó?" value={n ? n.toLocaleString('es-CO') : ''} onChange={(e) => setValor(e.target.value)} disabled={locked} data-testid="acc-valor" />
            </div>
            <button type="submit" className="acc-add" disabled={locked || !n} data-testid="acc-agregar">Agregar</button>
          </form>
          <button type="button" className="pf-continuar" disabled={locked || !items.length} onClick={() => setConfirmar(true)} data-testid="acc-listo">
            Ya los agregué todos
          </button>
        </>
      ) : (
        <div className="acc-conf">
          <p>{base
            ? `Tu carro quedaría asegurado por ${fmtPesos(base + total)}: ${fmtPesos(base)} de valor comercial más ${fmtPesos(total)} en accesorios. ¿Estás de acuerdo?`
            : `Tu carro se asegura por el valor de la factura más ${fmtPesos(total)} en accesorios. ¿Estás de acuerdo?`}</p>
          <div className="pf-opts">
            <button type="button" disabled={locked} onClick={() => onListo(texto())} data-testid="acc-si">Sí, de acuerdo</button>
            <button type="button" disabled={locked} onClick={() => setConfirmar(false)}>Quiero cambiar algo</button>
          </div>
        </div>
      )}
    </div>
  );
};
